import options from './thing-type.component';

export default {
    selector: 'dtAsThingType',
    options
};



// WEBPACK FOOTER //
// ./app/components/sensors-and-connectors/components/search/advanced/thing-type/index.js